import { Injectable } from '@angular/core';
import { STATIC_DATA } from '../shared/constants/static-data.constants';
import { NotificationService } from '../shared/services/notification.service';
import { formatUrl } from '../shared/utils/format-url-util';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class SectionsService {
  flow = '';
  private selected_enrollment?: any;
  private selected_association?: any;
  private lead_submission_flow?: string;
  tabChangedEvent$ = new BehaviorSubject<string>('');

  constructor(
    private notificationService: NotificationService,
    private userService: UserService
  ) { }

  changeTab(to: string) {
    this.tabChangedEvent$.next(to);
  }

  tabStatus(): Observable<any> {
    return this.tabChangedEvent$.asObservable();
  }

  clearTab() {
    this.tabChangedEvent$ = new BehaviorSubject<string>('');
  }

  getStep1(code: any) {
    const flow = this.getFlow();
    return require(`../../assets/data/programs/${code}/lead_logic/leadLogic_${flow}.json`);
  }

  getAllSteps(code: any) {
    const flow = this.getFlow();
    return require(`../../assets/data/programs/${code}/forms/${flow}/steps.json`);
  }

  getAdditionalDemoData(code:any){
    return require(`../../assets/data/programs/${code}/forms/providerEnrollment/wotc/provider.json`);
  }

  getProviderSteps(code: any) {
    const enrollmentType = this.getEnrollmentType();
    let enrollType;
    if (
      enrollmentType &&
      Array.isArray(enrollmentType) &&
      enrollmentType.length > 1
    ) {
      if (enrollmentType.includes('provider')) {
        enrollType = 'provider';
      } else if (enrollmentType.includes('authRepresentative')) {
        enrollType = 'authRepresentative';
      } else if (enrollmentType.includes('POA')) {
        enrollType = 'poa';
      } else if (enrollmentType.includes('legalGuardian')) {
        enrollType = 'legalGuardian';
      }
    } else {
      enrollType = enrollmentType[0];
    }
    return require(`../../assets/data/programs/${code}/forms/providerEnrollment/steps/${enrollType}.json`);
  }

  getEnrollmentAdditionData(code: any) {
    const flow = this.getFlow();
    return require(`../../assets/data/programs/${code}/enrollment/${flow}.json`);
  }

  getCDPAPData(code: any) {
    return require(`../../assets/data/programs/${code}/forms/cdpap/form.json`);
  }

  getSectionData(code: any, source?: any) {
    const flow = this.getFlow();
    if (source == 'enrollment') {
      return require(`../../assets/data/programs/${code}/forms/participantEnrollment/associations/${flow}.json`);
    }
    if (source == 'payroll') {
      return require(`../../assets/data/programs/${code}/forms/payroll/${flow}/form.json`);
    }
    if (source == 'authAllocation') {
      return require(`../../assets/data/programs/${code}/forms/participantEnrollment/authorization/form.json`);
    }
    if (source === 'case-manager') {
      return require(`../../assets/data/programs/${code}/forms/caseManager/form.json`);
    }
    if (source === 'config') {
      return require(`../../assets/data/programs/${code}/forms/config/form.json`);
    }
    if (source === 'configDomain') {
      return require(`../../assets/data/programs/${code}/forms/configDomain/form.json`);
    }
    if (source === 'lookupValueConfig') {
      return require(`../../assets/data/programs/${code}/forms/config/lookup/form.json`);
    }
    return require(`../../assets/data/programs/${code}/forms/${flow}/form.json`);
  }

  // getProviderSectionData(code: any, section: string) {
  //   const enrollmentType = this.getEnrollmentType();
  //   const sectionData: Record<string, any> = {};
  //   for (const [i, enrollType] of enrollmentType.entries()) {
  //     const config = require(`../../assets/data/programs/${code}/forms/providerEnrollment/associations/${enrollType}.json`);
  //     sectionData[enrollType] = config[section];
  //   }

  //   const secData = Object.values(sectionData);
  //   const finalSection = secData[0];
  //   const attributes = [...new Set(finalSection.attributes.map((e: any) => e.attribute_ID))];
  //   const validations = [...new Set(finalSection.validations.map((e: any) => e.whatToCheck))];

  //   if (secData.length > 0) {
  //     secData.forEach(section => {
  //       section.attributes.forEach((a: any) => {
  //         if(attributes.indexOf(a.attribute_ID) == -1) {
  //           finalSection.attributes.push(a);
  //         }
  //       });

  //       section.validations.forEach((a: any) => {
  //         if(validations.indexOf(a.whatToCheck) == -1) {
  //           finalSection.validations.push(a);
  //         }
  //       });
  //     });
  //   }

  //   return finalSection;
  // }

  getProviderSectionData(code: any, section: string) {
    const enrollmentType = this.getEnrollmentType();
    let enrollType;
    if (
      enrollmentType &&
      Array.isArray(enrollmentType) &&
      enrollmentType.length > 1
    ) {
      if (enrollmentType.includes('provider')) {
        enrollType = 'provider';
      } else if (enrollmentType.includes('authRepresentative')) {
        enrollType = 'authRepresentative';
      } else if (enrollmentType.includes('POA')) {
        enrollType = 'poa';
      } else if (enrollmentType.includes('legalGuardian')) {
        enrollType = 'legalGuardian';
      }
    } else {
      enrollType = enrollmentType[0];
    }

    const config = require(`../../assets/data/programs/${code}/forms/providerEnrollment/associations/${enrollType}.json`);
    return config[section];
  }

  setFlow(flow: any) {
    this.lead_submission_flow = flow;
  }

  getFlow() {
    return this.lead_submission_flow;
  }

  // // Set selected lead (store in-memory)
  // setSelectedLead(lead_submission_flow: string): void {
  //   this.lead_submission_flow = lead_submission_flow;
  // }

  // // Get selected lead (in-memory)
  // getSelectedLead(): string | undefined {
  //   return this.lead_submission_flow;
  // }

  setEnrollmentType(type: any) {
    this.selected_enrollment = type;
  }

  setAssocType(type: any) {
    this.selected_association = type;
  }

  getAssocType() {
    const enrollmentTypes = this.selected_association;
    return enrollmentTypes ? JSON.parse(enrollmentTypes) : [];
  }

  removeEnrollmentType() {
    this.selected_enrollment = null;
  }

  getEnrollmentType() {
    const enrollmentTypes = this.selected_enrollment;
    return enrollmentTypes ? JSON.parse(enrollmentTypes) : [];
  }

  async getJsonConfigurationData(
    urlTeamplate: string,
    entry?: any,
    comp?: any
  ) {
    const program = this.userService.getSelectedProgram();
    const code = program?.program_code ?? '';
    let url = '';
    const flow = entry === 'auth' ? 'authorizations' : entry;
    if (comp && Array.isArray(comp) && comp.length > 1) {
      if (comp.includes('provider')) {
        comp = ['provider'];
      } else if (comp.includes('authRepresentative')) {
        comp = ['authRepresentative'];
      } else if (comp.includes('POA')) {
        comp = ['POA'];
      } else if (comp.includes('legalGuardian')) {
        comp = ['legalGuardian'];
      }
      url = formatUrl(urlTeamplate, { code, flow, comp });
    } else {
      url = formatUrl(urlTeamplate, { code, flow, comp });
    }

    /* if (flow) {
      url = formatUrl(urlTeamplate, { code, flow });
    } else {
      url = formatUrl(urlTeamplate, { code });
    } */

    if (url) {
      const resp = await fetch(url)
        .then((response) => response.json())
        .catch(() =>
          this.notificationService.alert(
            'error',
            'Error Fetching Data',
            'Error fetching configuration data'
          )
        );

      return await resp;
    } else {
      return false;
    }
  }
}
